<template>
    <div class="p-fluid" style="direction: rtl">
        <div class="card p-d-flex p-jc-center">
            <DataTable
                    :exportFilename="`דוח התנהגות - ${new Date().toLocaleString() }`"
                    sortMode="multiple"
                    removableSort
                    ref="trackingTable"
                    :rowClass="rowClass"
                    :value="data"
                    :paginator="true"
                    :selection.sync="selectedItemsTracing"
                    :resizableColumns="false"
                    @cell-edit-complete="onCellEditComplete"
                    columnResizeMode="fit"
                    dataKey="id"
                    class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
                    :rows="50"
                    stateStorage="session"
                    stateKey="tracing-data-state"
                    editMode="cell"
                    :filters="filters"
                    :loading="loading"
                    sortField="enabled"
                    :sortOrder="1"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[20, 50, 200, 1000]"
                    currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
            >
                <!-- header -->

                <template #header>
                    <div class="p-p-2 table-header">
                        <div class="p-m-1 p-d-inline-flex">
                            <h1 style="text-align: center">
                                <i
                                        style="transform: scale(1.7)"
                                        class="p-p-3 pi pi-briefcase"
                                ></i>

                                | תיק אישי
                            </h1>
                        </div>

                        <div class="p-d-flex">
              <span class="p-mr-2 p-input-icon-left">
                <i class="pi pi-search"/>
                <InputText
                        v-model="filters['global']"
                        placeholder="חיפוש ראשי"
                />
              </span>
                            <Button
                                    v-tooltip.top="'ייצוא טבלה'"
                                    class="p-mr-2 p-button-warning"
                                    icon="pi pi-download"
                                    @click="exportCSV($event)"
                            />
                            <Button
                                    v-tooltip.top="'מחיקה'"
                                    v-if="
                  selectedItemsTracing.length > 0 &&
                  selectedItemsTracing.length < 5 &&
                  (permitToDelete || user.role === 'ADMIN')
                "
                                    icon="pi pi-trash"
                                    class="p-mr-2 p-button-danger"
                                    @click="isDialogDelete = true"
                            />
                            <Button
                                    v-if="
                  selectedItemsTracing.length > 0 &&
                  selectedItemsTracing.length < 5 &&
                  !permitToDelete &&
                  user.role !== 'ADMIN'
                "
                                    v-tooltip.top="'לא ניתן למחוק\n דיווחי מנהל'"
                                    icon="pi pi-trash"
                                    class="p-mr-2 p-button-secondary"
                            />
                            <Button
                                    v-tooltip.top="'ניתן למחוק\n רק עד 5 פריטים'"
                                    v-if="
                  selectedItemsTracing.length >= 5 &&
                  (!permitToDelete || user.role === 'ADMIN')
                "
                                    icon="pi pi-trash"
                                    class="p-mr-2 p-button-secondary"
                            />
                            <Button
                                    v-tooltip.top="'הוספה'"
                                    icon="pi pi-plus"
                                    class="p-mr-2 p-button-success"
                                    @click="isDialogAdd = true"
                            />
                        </div>
                    </div>
                </template>
                <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
                <Column
                        bodyStyle="text-align: center;"
                        selectionMode="multiple"
                        headerStyle="text-align: center; width: 3em"
                ></Column>

                <!-- teacher -->

                <Column
                        headerStyle="text-align: rtl"
                        bodyStyle="text-align: right;"
                        field="teacher"
                        header="מורה"
                        filterMatchMode="in"
                        filterField="teacher"
                        optionLabel="lastname"
                        sortable
                        sortField="teacher.firstname"
                >
                    <template #filter>
                        <MultiSelect
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                :filter="true"
                                :showClear="true"
                                dataKey="id"
                                :options="teachers"
                                v-model="filters['teacher']"
                                optionLabel="lastname"
                                placeholder="סנן לפי מורה"
                        >
                            <template #option="slotProps">
                <span>
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.firstname }}
                    {{ a.lastname }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </template>

                    <template #editor="slotProps">
                        <Dropdown
                                v-if="
                (slotProps.data.subject.role !== 'ADMIN' ||
                  user.role === 'ADMIN') &&
                slotProps.data.enabled !== true
              "
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                :filter="true"
                                optionLabel="lastname"
                                dataKey="id"
                                :value="slotProps.data[slotProps.column.field]"
                                :options="teachers"
                                placeholder="בחר מורה"
                                @input="onCellEdit($event, slotProps)"
                        >
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
                </span>
                            </template>
                            <template #option="slotProps">
                <span>
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
                            </template>
                        </Dropdown>
                        <div v-else>
                            {{ slotProps.data.subject.hebrewName }}
                        </div>
                    </template>

                    <template #body="slotProps">
                        <div>
                            {{ slotProps.data.teacher.firstname }}
                            {{ slotProps.data.teacher.lastname }}
                        </div>
                    </template>
                </Column>

                <!-- pupil -->

                <Column
                        headerStyle="width: 20%; text-align: rtl"
                        bodyStyle="text-align: right;"
                        field="pupil"
                        header="תלמיד"
                        filterMatchMode="in"
                        filterField="pupil"
                        sortable
                        sortField="pupil.lastname"
                >
                    <template #filter>
                        <MultiSelect
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                :showClear="true"
                                :filter="true"
                                dataKey="id"
                                :options="pupils"
                                v-model="filters['pupil']"
                                optionLabel="lastname"
                                placeholder="סנן לפי תלמיד"
                        >
                            <template #option="slotProps">
                <span
                >{{ slotProps.option.grade?.hebrewName }}:
                  {{ slotProps.option?.firstname }}
                  {{ slotProps.option?.lastname }}</span
                >
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.grade?.hebrewName }}: {{ a?.firstname }}
                    {{ a?.lastname }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </template>

                    <template #editor="slotProps">
                        <Dropdown
                                v-if="
                (slotProps.data.subject.role !== 'ADMIN' ||
                  user.role === 'ADMIN') &&
                slotProps.data.enabled !== true
              "
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                :filter="true"
                                optionLabel="lastname"
                                dataKey="id"
                                :value="slotProps.data[slotProps.column.field]"
                                :options="pupils"
                                placeholder="בחר תלמיד"
                                @input="onCellEdit($event, slotProps)"
                        >
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  {{ slotProps.value.grade.hebrewName }}:
                  {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
                </span>
                            </template>
                            <template #option="slotProps">
                <span
                >{{ slotProps.option.grade.hebrewName }}:
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
                            </template>
                        </Dropdown>

                        <div v-else>
                            {{ slotProps.data.pupil.firstname }}
                            {{ slotProps.data.pupil.lastname }}
                        </div>
                    </template>

                    <template #body="slotProps">
                        <div>
                            {{ slotProps.data.pupil.firstname }}
                            {{ slotProps.data.pupil.lastname }}
                        </div>
                    </template>
                </Column>

                <!-- content -->
                <Column
                        headerStyle="text-align: rtl"
                        bodyStyle="text-align: right; overflow: visible"
                        sortable
                        field="content"
                        header="תוכן"
                >
                    <template #filter>
                        <InputText
                                type="text"
                                v-model="filters['content']"
                                class="p-column-filter"
                                :placeholder="`חפש לפי תוכן`"
                        />
                    </template>
                    <template #editor="slotProps">
            <Textarea
                    autoResize="true"
                    v-if="
                (slotProps.data.subject.role !== 'ADMIN' ||
                  user.role === 'ADMIN') &&
                slotProps.data.enabled !== true
              "
                    :value="slotProps.data[slotProps.column.field]"
                    @input="onCellEdit($event, slotProps)"
            />
                        <div v-else>
                            {{ slotProps.data.content }}
                        </div>
                    </template>
                    <template #body="slotProps">
                        <p>{{ slotProps.data.content }}</p>
                    </template>
                </Column>

                <!-- date -->

                <Column
                        headerStyle="width: 15%; text-align: rtl"
                        bodyStyle="text-align: right;"
                        field="date"
                        header="תאריך"
                        filterMatchMode="custom"
                        :filterFunction="filterDate"
                        filterField="date"
                        sortable
                        sortField="date"
                >
                    <template #filter>
                        <Calendar
                                :touchUI="true"
                                :showButtonBar="true"
                                dateFormat="dd.mm.yy"
                                selectionMode="range"
                                v-model="filters['date']"
                                placeholder="סנן לפי תאריך"
                        />
                    </template>

                    <template #editor="slotProps">
                        <Calendar
                                v-if="
                (slotProps.data.subject.role !== 'ADMIN' ||
                  user.role === 'ADMIN') &&
                slotProps.data.enabled !== true
              "
                                :showTime="true"
                                :touchUI="true"
                                :showButtonBar="true"
                                dateFormat="dd.mm.yy"
                                id="basic"
                                :value="new Date(slotProps.data[slotProps.column.field])"
                                @input="onCellEdit($event, slotProps)"
                        />

                        <div v-else>
                            {{ new Date(slotProps.data.date).toLocaleString().split("T")[0] }}
                        </div>
                    </template>

                    <template #body="slotProps">
                        <div>
                            {{ new Date(slotProps.data.date).toLocaleString().split("T")[0] }}
                        </div>
                    </template>
                </Column>

                <!-- subject tracing -->

                <Column
                        headerStyle="width: 8%; text-align: rtl"
                        bodyStyle="text-align: center;"
                        field="subject"
                        header="נושא"
                        filterMatchMode="in"
                        filterField="subject"
                        sortable
                        sortField="subject.hebrewName"
                >
                    <template #filter>
                        <MultiSelect
                                filterPlaceholder=" חפש לפי נושא"
                                emptyFilterMessage=" לא נמצא שם נושא תואם"
                                :filter="true"
                                dataKey="id"
                                optionLabel="hebrewName"

                                v-model="filters['subject']"
                                :options="subjectTracing"
                                :showClear="true"
                                placeholder="סנן לפי נושא"
                        >
                            <template #option="slotProps">
                <span class="subject-tracking" :class="slotProps.option.type">{{
                        slotProps.option.hebrewName
                    }}</span>
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span
                          v-for="(subject, index) in slotProps.value"
                          :key="index"
                  >
                    <span class="subject-tracking" :class="subject.type">
                      {{ subject.hebrewName }},
                    </span>
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </template>

                    <template #editor="slotProps">
                        <Dropdown
                                v-if="
                (slotProps.data.subject.role !== 'ADMIN' ||
                  user.role === 'ADMIN') &&
                slotProps.data.enabled !== true
              "
                                :value="slotProps.data['subject']"
                                :options="subjectTracingFilter"
                                placeholder="בחר סוג"
                                @input="onCellEdit($event, slotProps)"
                        >
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span
                                        class="subject-tracking"
                                        :class="slotProps.value.type"
                                        v-else
                                >
                  {{ slotProps.value.hebrewName }}
                </span>
                            </template>
                            <template #option="slotProps">
                <span class="subject-tracking" :class="slotProps.option.type">
                  {{ slotProps.option.hebrewName }}</span
                >
                            </template>
                        </Dropdown>
                        <div class="subject-tracking" :class="slotProps.option.type" v-else>
                            {{ slotProps.data.subject.hebrewName }}
                        </div>
                    </template>

                    <template #body="slotProps">
                        <div class="subject-tracking" :class="slotProps.data.subject.type">
                            {{ slotProps.data.subject.hebrewName }}
                        </div>
                    </template>
                </Column>

                <!-- enabled -->

                <Column
                        field="enabled"
                        header="סטטוס"
                        filterField="enabled"
                        sortable
                        sortField="enabled"
                        headerStyle="width: 8%; text-align: center;  overflow: visible"
                        bodyStyle=" text-align: center;  overflow: visible; text-align: center ;"
                        filterMatchMode="equals"
                        bodyClass="ss"
                >
                    <template #filter>
                        <Dropdown
                                :showClear="true"
                                v-model="filters['enabled']"
                                :options="enabled"
                                placeholder="סנן לפי מצב"
                        >
                            <template #option="slotProps">
                                <span>{{ getEnabledLabel(slotProps.option) }}</span>
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <div v-else>{{ getEnabledLabel(slotProps.value) }},</div>
                            </template>
                        </Dropdown>
                    </template>

                    <template #editor="slotProps">
                        <Dropdown
                                v-if="
                slotProps.data.subject.role !== 'ADMIN' || user.role === 'ADMIN'
              "
                                class="zz"
                                :value="slotProps.data[slotProps.column.field]"
                                :options="enabled"
                                @input="onCellEdit($event, slotProps)"
                        >
                            <template #option="slotProps">
                                <span>{{ getEnabledLabel(slotProps.option) }}</span>
                            </template>
                            <template #value="slotProps">
                                <span>{{ getEnabledLabel(slotProps.value) }}</span>
                            </template>
                        </Dropdown>
                        <div v-else>
                            {{ getEnabledLabel(slotProps.data.enabled) }}
                        </div>
                    </template>

                    <template class="qq" #body="slotProps">
                        {{ getEnabledLabel(slotProps.data.enabled) }}
                    </template>
                </Column>

                <!-- user -->

                <Column
                        headerStyle="width: 8%; text-align: rtl"
                        bodyStyle="text-align: right; color: #0000004C;"
                        field="user"
                        header="מורה מדווח"
                        filterField="user"
                        filterMatchMode="custom"
                        :filterFunction="filterTeacher"
                        sortable
                        sortField="user.lastname"
                >
                    <template #filter>
                        <MultiSelect
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                :filter="true"
                                :showClear="true"
                                dataKey="id"
                                :options="teachers"
                                v-model="filters['user']"
                                optionLabel="lastname"
                                placeholder="סנן לפי מורה"
                        >
                            <template #option="slotProps">
                <span>
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.firstname }}
                    {{ a.lastname }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </template>

                    <template #body="slotProps">
                        <div>
                            {{ slotProps.data.user.firstname }}
                            {{ slotProps.data.user.lastname }}
                        </div>
                    </template>
                </Column>

                <!-- grade -->
                <Column
                        headerStyle="width: 8%; text-align: rtl"
                        bodyStyle="text-align: right;  color: #0000004C;"
                        field="grade"
                        header="כיתה"
                        filterMatchMode="in"
                        filterField="grade"
                        sortable
                        sortField="grade.hebrewName"
                >
                    <template #filter>
                        <MultiSelect
                                filterPlaceholder=" חפש לפי שם כיתה"
                                emptyFilterMessage=" לא נמצא שם כיתה תואם"
                                :filter="true"
                                dataKey="id"
                                optionLabel="hebrewName"
                                v-model="filters['grade']"
                                :options="gradeOptions"
                                :showClear="true"
                                placeholder="סנן לפי כיתה"
                        >
                            <template #option="slotProps">
                                <span>{{ slotProps.option.hebrewName }}</span>
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </template>

                    <template #body="slotProps">
                        <div>
                            {{ slotProps.data.grade.hebrewName }}
                        </div>
                    </template>
                </Column>

                <template #footer>
                    סה״כ {{ data ? data.length : 0 }} רשומות.
                    {{ tracingsEnablesSize }} אירועים שעדיין לא טופלו
                </template>
            </DataTable>
        </div>

        <add-Dialog
                :show="isDialogAdd"
                :teachers="teachers"
                v-on:addItem="addItem"
                v-on:closeDialog="isDialogAdd = false"
        >
        </add-Dialog>
        <delete-dialog
                :title="'מחיקה'"
                :context="`האם תרצה להסיר  ${selectedItemsTracing.length} רשומות מהמערכת?`"
                :show="isDialogDelete"
                v-on:choice="deleteItem"
        >
        </delete-dialog>
    </div>
</template>

<script>
import AddDialog from "../../dialogs/mainPost/TracingDialog";
import deleteDialog from "../../dialogs/DeleteDialog.vue";
import Service from "../../service/Service";

import Vue from "vue";
import {mapState} from "vuex";

export default {
    service: null,
    components: {
        AddDialog,
        deleteDialog,
    },
    created() {
        this.service = new Service();

    },
    async mounted() {
        this.filters = {
            subject: this.subjectTracing?.filter(subject => subject.alert === true),
            enabled: false
        }
        if (this.$route.query.pupil) {
            this.filters = {
                ...this.filters,
                pupil: [this.getPupilObj(this.$route.query.pupil)],
            }
        }
        if (this.$route.query.onlyAlert) {
            this.filters = {
                ...this.filters,
                subject: this.subjectTracing?.filter(subject => subject.alert === true),
            }
        }
        if (this.$route.query.subject) {
            this.filters = {
                ...this.filters,
                subject: [this.getSubjectTracingObj(this.$route.query.subject)],
            }
        }
        if (this.$route.query.start && this.$route.query.end) {
            const start = parseInt(this.$route.query.start)
            const end = parseInt(this.$route.query.end)
            this.filters = {
                ...this.filters,
                date: [new Date(start),new Date(end)],
            }
        }
        this.service.get(this.ENTITY).then((dataTracing) => {
            this.service.get("teacher").then((data) => {
                this.teachers = data;
                dataTracing.forEach((element) => {
                    element.subject = this.getSubjectTracingObj(element.subject);
                    element.grade = this.getGradeObj(element.grade);
                    if (element.pupil) element.pupil = this.getPupilObj(element.pupil);
                    if (element.teacher === null) {
                        element.teacher = this.getTeacherObj(element.user);
                    } else {
                        element.teacher = this.getTeacherObj(element.teacher);
                    }
                    element.user = this.getUserObj(element.user);
                });
                this.data = dataTracing;
                // this.selectedItemsTracing = []

                this.loading = false;
            });
        });
        setTimeout(() => {
            this.selectedItemsTracing = [];
        }, 500);
    },
    data() {
        return {
            ENTITY: "tracing",
            data: null,
            loading: true,
            isDialogDelete: false,
            isDialogAdd: false,
            selectedItemsTracing: [],
            teachers: null,
            filters: {},
            itemBeforeEditing: {},
            itemAfterEditing: {},
            enabled: [true, false],
        };
    },
    computed: {
        ...mapState([
            "pupils",
            "user",
            "lessonTime",
            "subjectTracing",
            "presenceStatus",
            "gradeOptions",
        ]),
        subjectTracingFilter() {
            if (this.user.role !== "ADMIN") {
                return this.subjectTracing.filter((s) => s.role !== "ADMIN");
            } else {
                return this.subjectTracing;
            }
        },
        permitToDelete() {
            let isPermit = true;
            this.selectedItemsTracing.forEach((item) => {
                if (item?.subject?.role === "ADMIN") isPermit = false;
            });
            return isPermit;
        },
        tracingsEnablesSize() {
            let countTracings = 0;
            this?.data?.forEach((item) =>
                item.enabled === false ? countTracings++ : null
            );
            return countTracings;
        },
    },
    methods: {
        exportCSV() {
            this.$refs.trackingTable.exportCSV({convertData: this.convertData});
        },
        convertData(data, field) {
            switch (field) {
                case "enabled":
                    return data ? "טופל" : "לא טופל"
                case "date":
                    return new Date(data)?.toLocaleDateString()
                case "grade":
                case "subject":
                    return data && data?.hebrewName
                case "teacher":
                case "user":
                case "pupil":
                    return `${data?.lastname} ${data?.firstname}`
                default:
                    return data
            }
        },
        getEnabledLabel(boolean) {
            switch (boolean) {
                case false:
                    return "לא טופל";

                case true:
                    return "טופל";

                default:
                    return "NA";
            }
        },
        getPupilObj(pupilId) {
            if (this.pupils.find((pupil) => pupil.id === pupilId) === undefined)
                return {
                    id: "0",
                    firstname: "error",
                    lastname: "*",
                    grade: {hebrewName: "*"},
                };
            else return this.pupils.find((pupil) => pupil.id === pupilId);
        },
        getTeacherObj(teacherId) {
            return this.teachers.find((teacher) => teacher.id === teacherId);
        },
        getUserObj(userId) {
            return this.teachers.find((teacher) => teacher.id === userId);
        },
        getSubjectTracingObj(subjectId) {
            if (
                this.subjectTracing.find(
                    (subjectTracing) => subjectTracing.id === subjectId
                ) === undefined
            )
                return "-";
            else
                return this.subjectTracing.find(
                    (subjectTracing) => subjectTracing.id === subjectId
                );
        },
        getGradeObj(gradeId) {
            return this.gradeOptions.find((grade) => grade.id === gradeId);
        },
        filterTeacher(value, filter) {
            if (
                filter.length === 0 ||
                filter === undefined ||
                filter === null ||
                (typeof filter === "string" && filter.trim() === "")
            ) {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }
            let isExist = false;
            filter.forEach((filter) => {
                if (filter.id === value.id) {
                    isExist = true;
                }
            });
            return isExist;
        },
        filterDate(value, filter) {
            if (
                filter === undefined ||
                filter === null ||
                (typeof filter === "string" && filter.trim() === "")
            ) {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }

            if (filter[1] !== null) {
                return value >= Date.parse(filter[0]) && value <= Date.parse(filter[1]);
            } else if (filter[1] === null) {
                const a = new Date(value);
                a.setDate(a.getDate() - 1);
                return a.getTime() === filter[0].getTime();
            }
            return true;
        },
        getTime(timerId) {
            return this.lessonTime.find((lTime) => lTime.id === timerId);
        },
        rowClass(data) {
            let rowClass = "";
            data.enabled === true ? (rowClass += "row-unenabled") : null;
            // data.subject.role === 'ADMIN' ? rowClass += "row-admin" : null;
            return rowClass;
        },

        addItem(item) {
            this.data.push(item);
        },
        deleteItem(choice) {
            this.isDialogDelete = false;
            if (choice) {
                this.loading = true;

                const itemsIds = [];
                const selscteds = this.selectedItemsTracing;
                this.selectedItemsTracing.forEach((item) => {
                    itemsIds.push(item.id);
                });

                this.service
                    .deleteMany(itemsIds, this.ENTITY)
                    .then(() => {
                        this.loading = false;
                        this.openNotification(
                            "success",
                            `מעולה`,
                            `מחקנו ${itemsIds.length}  רשומות מהמערכת`
                        );
                        selscteds.forEach((selected) => {
                            this.data = this.data.filter((item) => item.id !== selected.id);
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                        this.openNotification(
                            "danger",
                            `אופס`,
                            `לא הצלחנו למחוק את הרשומות מהמערכת`
                        );
                        this.data.push(...this.selectedItemsTracing);
                        this.selectedItemsTracing = [];
                    });

                this.isDialogDelete = false;
            }
            this.selectedItemsTracing = [];
        },

        async onCellEditComplete(event) {
            const index = this.data.findIndex(
                (item) => item.id === this.itemAfterEditing.id
            );
            this.data[index] = this.itemAfterEditing;

            Vue.set(this.data, index, this.itemAfterEditing);

            const clone = JSON.parse(JSON.stringify(this.itemAfterEditing));
            clone.grade = this.itemAfterEditing.grade.id;
            clone.subject = this.itemAfterEditing.subject.id;
            clone.pupil = this.itemAfterEditing.pupil.id;
            clone.teacher = this.itemAfterEditing.teacher.id;
            clone.user = this.itemAfterEditing.user.id;
            clone.date = this.itemAfterEditing.date;

            this.service
                .update(clone, this.ENTITY)
                .then(() => {
                })
                .catch(() => {
                    Vue.set(this.data, index, this.itemBeforeEditing);
                    this.openNotification(
                        "danger",
                        `אופס`,
                        `קרתה תקלה בעדכון הנתונים במערכת`
                    );
                });
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    },
};
</script>

<style scoped>
p {
    overflow-wrap: break-word;
}

::v-deep .row-unenabled {
    /*color: rgba(0, 0, 0, 0.3) !important;*/
}

::v-deep .row-admin {
    color: rgba(128, 12, 12, 0.93) !important;
}

::v-deep .row-unenabledrow-admin {
    color: rgba(118, 0, 0, 0.5) !important;
}
</style>
